import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ViewController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { ENV } from '@app/env'
import {Subject} from "rxjs";

@IonicPage()
@Component({
  selector: 'page-admin-users-add',
  templateUrl: 'admin-users-add.html',
})
export class AdminUsersAddPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  user: any = {};
  authuser: any = {};
  userdata: any = {};
  clinic_selected: any = {};
  isExisting = false;
  addeditType = 'Add';
  public clinicList: any[] = [];
  clinics: any[] = [];

  first_name: FormControl;
  last_name: FormControl;
  email: FormControl;
  // phone_number: FormControl;
  password: FormControl;
  clinic: FormControl;
  clinic_province: FormControl;
  role: FormControl;

  provinces: any[] = ENV.PROVINCES;

  constructor(public viewCtrl: ViewController, private database: DatabaseProvider, public params: NavParams, public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, private auth: AuthProvider, public loadingCtrl: LoadingController) {

    this.auth.getCurrentUser().then(user => {
      console.log(user);
      this.authuser = user;

    });

    this.clinics = params.get('clinics');
    console.log('Clinics: ', this.clinics)
    this.auth.getUserToken().then((token) => {
      // console.log('User Token: ', token);
    });

    this.first_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.last_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.email = new FormControl(
      "",
      Validators.compose([
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")
      ])
    );

    if (params.get('user')) {
      this.password = new FormControl("");
    } else {
      this.password = new FormControl(
        "",
        Validators.compose([
          Validators.minLength(8),
          Validators.maxLength(30),
          Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"),
          Validators.required
        ])
      );
    }
    // this.phone_number = new FormControl("", Validators.required);
    this.clinic_province = new FormControl("", Validators.required);
    this.clinic = new FormControl("", Validators.required);

    this.user = formBuilder.group({
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      // phone_number: this.phone_number,
      password: this.password,
      role: this.role,
      clinic_province: this.clinic_province,
      clinic: this.clinic
    });

    this.user.get('role').valueChanges.takeUntil(this.ngUnsubscribe).subscribe((role) => {
      let clinic = this.user.get('clinic');
      if ( role === "retina_pharmacist") {
        clinic.setValidators(null);
      } else {
        clinic.setValidators([Validators.required]);
      }
      clinic.updateValueAndValidity()
    });

    if (params.get('user')) {
      this.userdata = params.get('user');
      this.userdata.role =
        this.userdata.roles.retina_admin? "retina_admin":
          this.userdata.roles.clinic_admin? "clinic_admin":
            this.userdata.roles.retina_reporting? "retina_reporting": "retina_pharmacist";
      this.userdata.clinic = this.userdata.clinic_id;
      this.updateClinicList(this.userdata.clinic_province);
      this.clinic_selected = this.clinics.filter(x => x.id === this.userdata.clinic_id)[0];
      this.user.patchValue(this.userdata);
      this.isExisting = true;
      this.addeditType = "Edit " + this.userdata.first_name;
      console.log('Editing existing user: ', this.userdata);
    } else {
      
    }
  }

  ionViewDidLoad() {
    console.log('User form: ', this.user.get('clinic_province').value);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  showClinic(ev, clinic)  {
    this.clinic_selected = clinic;
  }

  createUser()  {
    let new_user = { ...this.user.value };
    new_user.roles = {
      retina_admin: new_user.role === "retina_admin",
      retina_reporting: new_user.role === "retina_reporting",
      retina_pharmacist: new_user.role === "retina_pharmacist",
      clinic_admin: new_user.role === "clinic_admin"
    };
    new_user['clinic_id'] = (new_user.role != "retina_pharmacist")? this.clinic_selected.id : "NA";
    new_user['clinic_name'] = (new_user.role != "retina_pharmacist")? this.clinic_selected.clinic_name : "NA";
    new_user['clinic_province'] = this.clinic_province.value;
    new_user['display_name'] = new_user.first_name + ' ' + new_user.last_name;
    new_user['phone_number'] = null;

    delete new_user.clinic;
    delete new_user.role;
    console.log('Creating new user: ', new_user);
    const loader = this.loadingCtrl.create({
      content: "Creating User..."
    });

    loader.present()
    this.database.createUser(new_user).then((result) => {
      loader.dismiss().then(() => {
        console.log('create user: ', result);
        this.dismiss();
      })
      

    })
    .catch((error) => {
      loader.dismiss();
      console.log('create user error: ', error);
    })
  }

  updateUser()  {
    let update_user = { id: this.userdata.id, ...this.user.value };
    update_user.roles = {
      retina_admin: update_user.role === "retina_admin",
      retina_reporting: update_user.role === "retina_reporting",
      retina_pharmacist: update_user.role === "retina_pharmacist",
      clinic_admin: update_user.role === "clinic_admin"
    };
    update_user['clinic_id'] = (update_user.role != "retina_pharmacist")? this.clinic_selected.id : "NA";
    update_user['clinic_name'] = (update_user.role != "retina_pharmacist")? this.clinic_selected.clinic_name : "NA";
    update_user['clinic_province'] = this.clinic_province.value;
    update_user['display_name'] = update_user.first_name + ' ' + update_user.last_name;
    update_user['phone_number'] = null;

    delete update_user.clinic;
    delete update_user.password;
    delete update_user.role;

    console.log('Update user: ', update_user);
    const loader = this.loadingCtrl.create({
      content: "Updating User..."
    });

    loader.present();
    this.database.updateUser(this.userdata.id, update_user).then((result) => {
      loader.dismiss().then(() => {
        console.log('udpated user: ', result);
        this.dismiss();
      })
    })
    .catch((error) => {
      loader.dismiss();
      console.log('update user error: ', error);
    })
  }

  compareFn(e1: any, e2: any): boolean {
    return e1 && e2 ? e1.id === e2.id : e1 === e2;
  }

  updateClinicList(province)  {
    province = province ? province : 'ON'
    this.clinicList = this.clinics.filter(x => province.includes(x.address.province));
    console.log('Update clinics: ', this.clinicList);
  }

  ngOnDestroy() {
    console.log('Leave order and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-users-add/admin-users-add.ts